import axios, { AxiosError } from 'axios';
import { HIVE_HOME_URL } from '@/constants';
import { clearToken, getToken, getTokenForExternalApp } from '@/services/auth-service';

const axiosBaseInterceptorResponseErrorHandler = (error: AxiosError): void => {
  const { response: { status } = { status: null } } = error;
  if (status === 401) {
    clearToken();
    window.location.href = HIVE_HOME_URL + '/login';
  }
  if (status === 403) {
    clearToken();
    window.location.href = HIVE_HOME_URL + '/403.html';
  }
};

const axiosBase = axios.create();

axiosBase.interceptors.request.use(async config => {
  config.headers.Authorization = `Bearer ${getToken()}`;
  return config;
});

axiosBase.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    axiosBaseInterceptorResponseErrorHandler(error);
    return error;
  }
);

const axiosBaseForExternalApp = axios.create();

axiosBaseForExternalApp.interceptors.request.use(async config => {
  config.headers.Authorization = `Bearer ${getTokenForExternalApp()}`;
  return config;
});

axiosBaseForExternalApp.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    axiosBaseInterceptorResponseErrorHandler(error);
    return error;
  }
);

export { axiosBase, axiosBaseForExternalApp };
